﻿(function (angular) {
  "use strict";

  /*
   * Adapted from:
   * https://xebia.com/blog/cancelling-http-requests-for-fun-and-profit/
   */

  angular.module("angularCancelOnNavigateModule", []).config([
    "$httpProvider",
    function ($httpProvider) {
      $httpProvider.interceptors.push("HttpRequestTimeoutInterceptor");
    },
  ]);

  angular.module("angularCancelOnNavigateModule").service("HttpPendingRequestsService", [
    "$q",
    function ($q) {
      var cancelDeferreds = [];

      function newTimeoutDeferred(existingTimeoutDeferred) {
        var cancelDeferred;
        if (existingTimeoutDeferred) {
          cancelDeferred = existingTimeoutDeferred.deferred; // custom property added just to make this "layering" work
        } else {
          cancelDeferred = $q.defer();
        }

        cancelDeferreds.push(cancelDeferred);

        return cancelDeferred.promise;
      }

      function cancelAll() {
        angular.forEach(cancelDeferreds, function (cancelDeferred) {
          cancelDeferred.promise.isGloballyCancelled = true;
          cancelDeferred.resolve();
        });

        cancelDeferreds.length = 0;
      }

      return {
        newTimeoutDeferred: newTimeoutDeferred,
        cancelAll: cancelAll,
      };
    },
  ]);

  angular.module("angularCancelOnNavigateModule").factory("HttpRequestTimeoutInterceptor", [
    "$q",
    "HttpPendingRequestsService",
    function ($q, HttpPendingRequestsService) {
      return {
        request: function (config) {
          /* eslint-disable no-param-reassign */
          config = config || {};
          /* eslint-enable no-param-reassign */

          if (!config.noCancelOnRouteChange) {
            // If there is an existing timeout promise, "steal" it
            config.timeout = HttpPendingRequestsService.newTimeoutDeferred(config.timeout);
          }

          return config;
        },

        responseError: function (response) {
          if (response.config.timeout.isGloballyCancelled) {
            return $q.defer().promise;
          }

          return $q.reject(response);
        },
      };
    },
  ]);
})(window.angular);
